import api from '../../utils/api'

import { useState, useEffect } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormSystemUser from './components/FormSystemUser'

function NewSystemUser({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [myPermission, setMyPermission] = useState({ group: "" })
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get('/user/get/permission', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` }
        }).then((response) => {
            setMyPermission(response.data.permission)
        })
    }, [token])

    async function registerSystemUser(user) {
        let msgType = 'success'

        const data = await api.post('/user/register', user, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            <FormSystemUser
                title="Novo Usuário do Sistema"
                changePassword="disable"
                permissionData={myPermission}
                userData={{ permission: {} }}
                handleSubmit={registerSystemUser}
                btCancelAction={btCancelAction}
                btnText="Cadastrar"
            />
        </section>
    )
}

export default NewSystemUser
